import {icon, iconColor} from '#core/utils/style-utils.js';
import {resolveBackground} from '#core/utils/color-utils.js';
import {merge} from '#core/utils/config-utils.js';

import {generateSecondaryButton} from '#core/application/modules/tiles/button/index.js';
import {generateRangeInputComponent} from '#core/application/modules/tiles/range-input/index.js';

export function getVideoStreamingConfig(PALETTE) {
    return {
        VideoStream: {
            container: {
                style: {
                    _mobile_padding: '8px 0 0',
                    _mobile_boxShadow: PALETTE.VIDEO_STREAMING_CONTAINER_SHADOW,
                    ...resolveBackground(PALETTE.VIDEO_STREAMING_CONTAINER_BG),
                    ...PALETTE.VIDEO_STREAMING_STATUSBAR_TEXT,
                },
            },
            loginButton: merge(generateSecondaryButton(PALETTE.VIDEO_STREAM_LOGIN_BUTTON), {
                style: {
                    base: {
                        padding: '0 16px',
                    },
                },
            }),
            errorText: {
                style: {
                    textAlign: 'center',
                },
            },
            spinner: {
                image: icon(PALETTE.VIDEO_STREAMING_STATUSBAR_TEXT.color),
                style: {
                    container: {
                        alignSelf: 'center',
                    },
                },
            },
            beterPlayer: {
                style: {
                    borderStyle: 'none',
                },
            },
        },
        VideoPlayer: {
            errorMessage: {
                style: {
                    base: PALETTE.VIDEO_STREAMING_MESSAGES_TEXT,
                },
            },
            errorOverlay: {
                style: {
                    ...resolveBackground(PALETTE.VIDEO_STREAMING_MESSAGES_OVERLAY_BG),
                },
            },
            streamEndedMessage: {
                style: PALETTE.VIDEO_STREAMING_MESSAGES_TEXT,
            },
            streamEndedOverlay: {
                style: {
                    ...resolveBackground(PALETTE.VIDEO_STREAMING_MESSAGES_OVERLAY_BG),
                },
            },
            topContainer: {
                style: {
                    ...resolveBackground(PALETTE.VIDEO_STREAMING_CONTAINER_SCRIM),
                },
            },
            bottomContainer: {
                style: {
                    ...resolveBackground(PALETTE.VIDEO_STREAMING_CONTAINER_SCRIM),
                },
            },
            playButtonIcon: {
                style: {
                    fill: PALETTE.VIDEO_STREAMING_CONTROLS_COLOR,
                },
            },
            muteButtonIcon: {
                style: {
                    fill: PALETTE.VIDEO_STREAMING_CONTROLS_COLOR,
                },
            },
            closeButtonIcon: {
                style: {
                    fill: PALETTE.VIDEO_STREAMING_CONTROLS_COLOR,
                },
            },
            fullScreenButtonIcon: {
                style: {
                    fill: PALETTE.VIDEO_STREAMING_CONTROLS_COLOR,
                },
            },
            volumeSlider: generateRangeInputComponent(
                {
                    RANGE_THUMB_COLOR: PALETTE.VIDEO_STREAMING_CONTROLS_COLOR,
                },
                {BORDER_RADIUS: 1}
            ),
        },
        WatchButtonView: {
            button: {
                style: {
                    base: {
                        _desktop_minHeight: '32px',
                        _mobile_minHeight: '32px',
                        margin: '0px',
                        alignItems: 'center',
                        ...PALETTE.WATCH_BUTTON.TERTIARY_BUTTON_TEXT,
                    },
                },
            },
            icon: iconColor(PALETTE.WATCH_BUTTON.TERTIARY_BUTTON_ICON_COLOR),
        },
    };
}
